<iframe *ngIf="safeUrl && height && width" [src]="safeUrl" [width]="width" [height]="height" frameborder="0" class="auth-iframe"></iframe>
